<template>
    <div>
        <page-title-bar></page-title-bar>
        <page-tool-bar
        show_search
        show_month
        show_date_start
        show_date_end
        :is_date_start_disabled="true"
        :is_date_end_disabled="true"
        :min_month="'2025-06'"
        :loading="loader"
        :search.sync="search"
        :chosen_month.sync="chosen_month"
        :date_start.sync="date_start"
        :date_end.sync="date_end"
      >
      </page-tool-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap>
            <v-flex xs12 md12>
                <div class="text-right">
                    <v-btn
						@click="getData"
						:disabled="loader || is_analysis_locked"
						color="primary"
					>
						Lấy dữ liệu
					</v-btn>
                    <v-btn
						:loading="loader"
						:disabled="is_analysis_locked || loader"
						color="warning"
                        @click="finalizeAnalyses"
					>
						<v-icon small left>
							{{ is_analysis_locked ? "lock" : "lock_open"}}
						</v-icon>
						{{ is_analysis_locked ? `Đã chốt báo cáo` : "Chốt báo cáo"}}
					</v-btn>
                    <v-btn
						:disabled="export_csv.loading ||loader"
						:loading="export_csv.loading"
						@click="exportCSV"
						color="green"
						class="white--text"
					>
						<v-icon small left>archive</v-icon>
						XUẤT EXCEL
					</v-btn>
                    <export-csv-button
                        :trigger="export_csv.trigger"
                        :title="export_csv.title"
                        :rows="export_csv.rows"
                    ></export-csv-button>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <!-- Dòng tổng tiêu thụ -->
                <v-card class="mb-3" v-if="items && items.length > 0">
                    <v-card-text class="pa-3">
                        <v-layout row wrap align-center>
                            <v-flex xs12>
                                <h4 class="text-center mb-2">TỔNG TIÊU THỤ NƯỚC</h4>
                                <v-layout row wrap justify-center>
                                    <v-flex xs3>
                                        <div class="text-center">
                                            <div class="text-h6 font-weight-bold primary--text">
                                                {{ totalConsumption.two_months_ago | formatNumber }}
                                            </div>
                                            <div class="text-caption grey--text">
                                                Tháng {{ twoMonthsAgoLabel }}
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs3>
                                        <div class="text-center">
                                            <div class="text-h6 font-weight-bold info--text">
                                                {{ totalConsumption.previous_month | formatNumber }}
                                            </div>
                                            <div class="text-caption grey--text">
                                                Tháng {{ prevMonthLabel }}
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs3>
                                        <div class="text-center">
                                            <div class="text-h6 font-weight-bold success--text">
                                                {{ totalConsumption.current_month | formatNumber }}
                                            </div>
                                            <div class="text-caption grey--text">
                                                Tháng {{ currentMonthLabel }}
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

                <v-card>
                    <v-data-table
                        disable-initial-sort
                        :headers="dynamicHeaders"
                        :items="items"
                        item-key="room_id"
                        :rows-per-page-items="rowPerPage"
                        :search="search"
                        :loading="loader"
                    >
                            <template #headers="props">
                            <tr>
                                <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <tr>
                                <td class="text-center text-no-wrap">{{ props.item.building }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.customer_count || 0 }}</td>
                                <td class="text-center text-no-wrap" v-if="!is_analysis_locked">
                                    <v-edit-dialog
                                        large
                                        lazy
                                        @save="updateDevices(props.item)"
                                        @open="openDeviceEdit(props.item)"
                                    >
                                        <template v-slot:input>
                                            <v-card>
                                                <v-card-title>
                                                    Chọn thiết bị cho phòng {{ props.item.building }} - {{ props.item.room_id }}
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-checkbox
                                                        v-for="(abbreviation, device) in UTILITY_DEVICES"
                                                        :key="abbreviation"
                                                        v-model="props.item.devices_temp"
                                                        :label="`${device} (${abbreviation})`"
                                                        :value="abbreviation"
                                                        color="primary"
                                                    ></v-checkbox>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                        <template v-slot:default>
                                            <div class="text-center text-no-wrap">
                                                {{ props.item.devices ? props.item.devices.join(', ') : '' }}
                                            </div>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td v-else class="text-center text-no-wrap">
                                    {{ props.item.devices ? props.item.devices.join(', ') : '' }}
                                </td>


                                <td class="text-center text-no-wrap">{{ props.item.two_months_ago_consumption | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.previous_month_consumption | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.consumption | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.average_consumption | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.two_month_difference | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.average_difference | formatNumber }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.two_month_difference_rate | formatNumber }}%</td>
                                <td class="text-center text-no-wrap">{{ props.item.average_difference_rate | formatNumber }}%</td>
                            </tr>
                        </template>
                        <template #no-data>
                            Chưa có thông tin
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    </div>
</template>

<script>
import api from "Api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer } from 'Helpers'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'

export default {
    name: 'phan-tich-phai-thu-khach-hang-nuoc',
    components: {
        ExportCsvButton
    },
    data() {
        return {
            loader: false,
            menu_month_picker: false,
            headers: [
                { text: "Tòa nhà", align: "center", sortable: false, value: "building" },
                { text: "Phòng", align: "center", sortable: false, value: "room_id" },
                { text: "Số người", align: "center", sortable: false, value: "customer_counts" },
                { text: "Các vật dụng", align: "center", sortable: false, value: "devices" },
                { text: "", align: "center", sortable: false, value: "two_months_ago_consumption" },
                { text: "", align: "center", sortable: false, value: "previous_month_consumption" },
                { text: "", align: "center", sortable: false, value: "consumption" },
                { text: "Tiêu thụ trung bình", align: "center", sortable: false, value: "average_consumption" },
                { text: "CL 2 tháng", align: "center", sortable: false, value: "two_month_difference" },
                { text: "CL vs TB", align: "center", sortable: false, value: "average_difference" },
                { text: "Tỷ lệ chênh lệch 2 tháng", align: "center", sortable: false, value: "two_month_difference_rate" },
                { text: "Tỷ lệ chênh lệch với TB", align: "center", sortable: false, value: "average_difference_rate" },
            ],
            items: [],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            chosen_month: new Date().toISOString().substring(0, 7),
            date_start: '',
            date_end: '',
            search: '',
            export_csv: {
                trigger: false,
                title: '',
                rows: [],
                loading: false,
            },
            is_analysis_locked: false,
            UTILITY_DEVICES: {
                'Tủ lạnh': 'TL',
                'Máy lạnh': 'ML', 
                'Máy giặt': 'MG',
                'Máy quạt': 'MQ',
                'Bếp điện': 'BD',
                'Bếp ga': 'BG',
                'Ấm điện': 'AD'
            },
        }
    },
    computed: {
        dynamicHeaders() {
            const currentMonth = moment(this.chosen_month);
            const prevMonth = moment(this.chosen_month).subtract(1, 'month');
            const twoMonthsAgo = moment(this.chosen_month).subtract(2, 'month');
            
            return this.headers.map(header => {
                if (header.value === 'two_months_ago_consumption') {
                    return {
                        ...header,
                        text: `Tiêu thụ tháng ${twoMonthsAgo.format('M')}`
                    };
                }
                if (header.value === 'previous_month_consumption') {
                    return {
                        ...header,
                        text: `Tiêu thụ tháng ${prevMonth.format('M')}`
                    };
                }
                if (header.value === 'consumption') {
                    return {
                        ...header,
                        text: `Tiêu thụ tháng ${currentMonth.format('M')}`
                    };
                }
                return header;
            });
        },
        rooms(){
            return this.$store.state.app.rooms
        },
        totalConsumption() {
            if (!this.items || this.items.length === 0) {
                return {
                    two_months_ago: 0,
                    previous_month: 0,
                    current_month: 0,
                };
            }

            const totals = this.items.reduce((acc, item) => {
                acc.two_months_ago += parseFloat(item.two_months_ago_consumption || 0);
                acc.previous_month += parseFloat(item.previous_month_consumption || 0);
                acc.current_month += parseFloat(item.consumption || 0);
                return acc;
            }, {
                two_months_ago: 0,
                previous_month: 0,
                current_month: 0,
            });

            return {
                two_months_ago: totals.two_months_ago,
                previous_month: totals.previous_month,
                current_month: totals.current_month,
            };
        },
        // Labels cho các tháng
        twoMonthsAgoLabel() {
            return moment(this.chosen_month).subtract(2, 'month').format('M/YYYY');
        },
        prevMonthLabel() {
            return moment(this.chosen_month).subtract(1, 'month').format('M/YYYY');
        },
        currentMonthLabel() {
            return moment(this.chosen_month).format('M/YYYY');
        },
    },
    watch: {
        chosen_month: function(nv){
            if (nv) {
                this.generatePeriod();
                this.checkAnalysisLockedAndGetData();
            }
        },
    },
    mounted() {
        this.generatePeriod();
        this.checkAnalysisLockedAndGetData();
    },
    methods: {
        generatePeriod() {
            const [year, monthNum] = this.chosen_month.split('-').map(Number);
            
            // date_start: ngày 12 của tháng trước
            let startMonth = monthNum - 1;
            let startYear = year;
            if (startMonth <= 0) {
                startMonth = 12;
                startYear = year - 1;
            }
            const date_start = `${startYear}-${startMonth.toString().padStart(2, '0')}-12`;
            
            const date_end = `${year}-${monthNum.toString().padStart(2, '0')}-11`;
            
            this.date_start = date_start;
            this.date_end = date_end;
        },
        async getAnalysisLog() {
            const logParams = {
                month: this.chosen_month,
            };
            const logQuery = buildParamQuery(logParams);    
            const logData = await api.getWaterConsumptionAnalysisLog(logQuery);

            return logData.data;    
        },
        async checkAnalysisLockedAndGetData() {
            this.loader = true;
            const logData = await this.getAnalysisLog();
            if (logData) {
                this.is_analysis_locked = true;
                await this.getData();
            } else {
                this.is_analysis_locked = false;
                this.items = [];
            }
            this.loader = false;
        },
        async getData() {
            try {
                this.items = [];

                this.loader = true;

                const params = {
                    date_start: this.date_start,
                    date_end: this.date_end,
                    month: this.chosen_month,
                };

                const devicesParams = {
                    month: this.chosen_month,
                };

                const query = buildParamQuery(params);
                const devicesQuery = buildParamQuery(devicesParams);

                this.loader = true;
                const [data, devicesData] = await Promise.all([
                    api.getWaterConsumptionAnalysis(query),
                    api.getUtilityConsumptionAnalysisDevice(devicesQuery),
                ]);
                
                if (data && data.data) {
                    this.items = this.rooms.map(room => {
                        const item = data.data.find(item => item.room_id === room.room_id);
                        const roomDevicesInfo = devicesData.data.find(device => device.room_id === room.room_id);
                        return {
                            ...item,
                            devices: roomDevicesInfo ? roomDevicesInfo.devices : [],
                        };
                    });
                }
            } catch (error) {
                console.error("🚀 ~ getData ~ error:", error)
            } finally {
                this.loader = false;
                console.log("🚀 ~ getData ~ this.loader:", this.loader)
            }
        },
        async finalizeAnalyses() {
            this.loader = true;

            const data = await api.finalizeWaterConsumptionAnalysis({
                month: this.chosen_month,
                date_start: this.date_start,
                date_end: this.date_end,
                analyses: this.items.filter(item => item && item.room_id),
            });

            if (data.status === 200){
                swal.fire('Hoàn Thành', data.data.message, 'success')
                this.is_analysis_locked = true;
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }

            this.loader = false;
        },
        openDeviceEdit(item) {
            // Tạo bản sao của devices để edit
            this.$set(item, 'devices_temp', [...(item.devices || [])]);
        },
        
        async updateDevices(item) {
            try {
                // Cập nhật devices từ temp
                const devices = [...(item.devices_temp || [])];
                
                // Gọi API để lưu
                const updateData = {
                    month: this.chosen_month,
                    building: item.building,
                    room_id: item.room_id,
                    devices,
                };
                
                const data = await api.updateUtilityConsumptionAnalysisDevice(updateData);

                if (data.status === 200){
                    swal.fire('Hoàn Thành', data.data.message, 'success')
                    this.$set(item, 'devices', devices);
                } else {
                    swal.fire('Lỗi', data.message, 'error')
                }
            } catch (error) {
                console.error('Error updating devices:', error);
            }
        },
        exportCSV() {
            // Kiểm tra dữ liệu trước khi export
            if (!this.items || this.items.length === 0) {
                swal.fire('Cảnh báo', 'Không có dữ liệu để xuất. Vui lòng tải dữ liệu trước.', 'warning');
                return;
            }

            const currentMonth = moment(this.chosen_month);
            const prevMonth = moment(this.chosen_month).subtract(1, 'month');
            const twoMonthsAgo = moment(this.chosen_month).subtract(2, 'month');
            
            // Format số thập phân cho các giá trị
            const formatNumber = (value) => {
                if (value === null || value === undefined) return 0;
                return typeof value === 'number' ? value.toFixed(2) : value;
            };

            // Format phần trăm
            const formatPercentage = (value) => {
                if (value === null || value === undefined) return '0%';
                return typeof value === 'number' ? `${value.toFixed(2)}%` : '0%';
            };
            
            const rows = this.items.map(item => {
                return {
                    "Tòa nhà": item.building || '',
                    "Phòng": item.room_id || '',
                    "Số người": item.customer_count || 0,
                    "Các vật dụng": item.devices && item.devices.length > 0 ? item.devices.join(', ') : 'Không có',
                    [`Tiêu thụ tháng ${twoMonthsAgo.format('M/YYYY')}`]: formatNumber(item.two_months_ago_consumption),
                    [`Tiêu thụ tháng ${prevMonth.format('M/YYYY')}`]: formatNumber(item.previous_month_consumption),
                    [`Tiêu thụ tháng ${currentMonth.format('M/YYYY')}`]: formatNumber(item.consumption),
                    "Tiêu thụ trung bình": formatNumber(item.average_consumption),
                    "Chênh lệch 2 tháng": formatNumber(item.two_month_difference),
                    "Chênh lệch vs TB": formatNumber(item.average_difference),
                    "Tỷ lệ chênh lệch 2 tháng": formatPercentage(item.two_month_difference_rate),
                    "Tỷ lệ chênh lệch với TB": formatPercentage(item.average_difference_rate),
                };
            });

            this.export_csv.rows = rows;
            this.export_csv.title = this.chosen_month + "-ptptkh-nuoc";
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
};
</script> 